export enum AudienceBreakdownSection {
  HOLDOUT = 'Holdout group',
  TEST = 'Test group',
  OPTIMIZED = 'Optimized group',
}

export type AudienceBreakdownSubSection = {
  alphabet: string;
  color: string;
  backgroundColor: string;
  borderColor: string;
  sends: number;
  percent: number;
};

export type AudienceBreakdownMetric = {
  label: AudienceBreakdownSection;
  percent: number;
  total: number;
  subsections: AudienceBreakdownSubSection[];
};
